const state = {
  id: undefined,
  brand_id: undefined,
  designer_id: undefined,
  designer_type: '',
  height: null,
  hidden: false,
  measurement_unit: '',
  provider_id: undefined,
  short_name: '',
  title: '',
  width: null,
}

export const requiredFields = [
  { key: 'designer_id' },
  { key: 'designer_type' },
  { key: 'brand_id' },
  { key: 'title' },
  { key: 'short_name' },
  { key: 'width' },
  { key: 'height' },
]

export default state
